import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as func from "../../common/tenvicCommon/FunctionCalls";
import * as api from "../../common/tenvicCommon/API";
import { usePermissions } from "../../common/PermissionContext";
import { useLocation, Link } from "react-router-dom";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Swal from "sweetalert2";
import Select from "react-select";
import Utils from "../../common/tenvicCommon/Utils";

const MenuRole = () => {

    const [rolesList, setRolesList] = useState<any[]>([]);
    const [menuList, setMenuList] = useState<any[]>([]);
    const [menuRoleList, setMenuRoleList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [roleId, setRoleId] = useState("");
    const [menuId, setMenuId] = useState("");
    const [menuRoleId, setMenuRoleId] = useState("");
    const [menuRoleStatus, setMenuRoleStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    useEffect(() => {
        async function fetchMenuRole() {
            setIsLoading(true);
            const mnuRleResponse = await func.listMenuRole();
            setMenuRoleList(Array.isArray(mnuRleResponse) ? mnuRleResponse : [])
            const rleResponse = await func.listRoles();
            setRolesList(Array.isArray(rleResponse) ? rleResponse : [])
            setIsLoading(false);
        }
        fetchMenuRole();
    }, [])

    const filteredData = menuRoleList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const menuNameRender = (rowData) => {
        return <span>{rowData.internalMenuTitle}</span>;
    };

    const roleRender = (rowData) => {
        return <span>{rowData.internalRoleName}</span>;
    };

    const menuRoleStatusRender = (rowData) => {
        return <span>{(rowData.internalMenuRoleStatus == 1) ? "Active" : "Inactive"}</span>;
    };

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editMenuRole(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const mnuRleId = rowData.internalMenuRoleId;
        return (
            <Link to="#" onClick={() => deleteMenuRole(mnuRleId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    function newMenuRole() {
        setIsEdit(false)
        setOpenModal(true)
        setMenuList([]);
        setMenuId("");
        setRoleId("");
    }


    async function editMenuRole(rowData) {
        const mnuRleId = rowData.internalMenuRoleId;
        setIsEdit(true)
        setOpenModal(true)
        const mnuResponse = await func.listMenus();
        setMenuList(Array.isArray(mnuResponse) ? mnuResponse : [])
        const getDetails = await func.getMenuRole(mnuRleId);
        setMenuRoleId(mnuRleId)
        setRoleId(getDetails.internalRoleId);
        setMenuId(getDetails.internalMenuId);
        setMenuRoleStatus(getDetails.internalMenuRoleStatus)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateMenuRole();
            } else {
                if (roleId && menuId) {
                    const formData = new FormData();
                    formData.append("menuId", menuId);
                    formData.append("roleId", roleId);

                    const createMenuRole = api.AddMenuRole;
                    fetch(createMenuRole, {
                        method: "POST",
                        headers: {
                            "Authorization": 'Bearer ' + Utils.getAccessToken()
                        },
                        body: formData
                    })
                        .then((response) => response.json())
                        .then((result) => {
                            if (result.error == false) {
                                Swal.fire({
                                    title: 'Success',
                                    text: result.message,
                                    icon: 'success',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            } else {
                                Swal.fire({
                                    title: 'Error',
                                    text: result.message,
                                    icon: 'error',
                                    confirmButtonText: 'OK',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false
                                }).then((res) => {
                                    if (res.isConfirmed) {
                                        window.location.reload(); // 🔁 Reload only after OK is clicked
                                    }
                                });
                            }
                        })
                }
            }
        }
    }

    function updateMenuRole() {
        const formData = new FormData();
        formData.append("roleId", roleId);
        formData.append("menuId", menuId);
        formData.append("menuRoleStatus", menuRoleStatus);

        const updateMenuRole = api.UpdateMenuRole + '/' + menuRoleId;
        fetch(updateMenuRole, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })
    }

    function deleteMenuRole(mnuRleId) {
        const deleteMenuRole = api.DeleteMenuRole + '/' + mnuRleId;
        fetch(deleteMenuRole, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                } else {
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            window.location.reload(); // 🔁 Reload only after OK is clicked
                        }
                    });
                }
            })

    }

    return (
        <>
            {isLoading && (

                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Menu Role</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn btn-secondary"
                                            onClick={() => { newMenuRole() }}>
                                            <i className="feather-plus" />&nbsp;
                                            Create Menu Role
                                        </Link>
                                        : null}
                                </div>
                                <div className="col-md-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalRoleName"
                                                header="Role Name"
                                                body={roleRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalMenuTitle"
                                                header="Menu Name"
                                                body={menuNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="internalMenuRoleStatus"
                                                header="Menu Role Status"
                                                body={menuRoleStatusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null}
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                openModal && (
                    <Modal
                        show={openModal}
                        size="md"
                        centered>
                        <ModalHeader>
                            <ModalTitle>
                                <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Menu Role</h4>
                            </ModalTitle>
                            <Button
                                variant=""
                                className="btn-close"
                                onClick={() => setOpenModal(false)}
                            ></Button>
                        </ModalHeader>
                        <ModalBody>
                            <form>
                                <div className="col-lg-12 mb-10">
                                    <label className="sortbytitle"><h6>Role</h6></label>
                                    <Select
                                        value={rolesList.find(role => role.internalRoleId === roleId) ? {
                                            value: roleId,
                                            label: rolesList.find(role => role.internalRoleId === roleId).internalRoleName
                                        } : null}
                                        onChange={async (e) => {
                                            setRoleId(e.value);
                                            setMenuList(await func.listMenus())
                                        }}
                                        required
                                        placeholder="Select Role"
                                        options={rolesList.map(role => ({
                                            value: role.internalRoleId,
                                            label: role.internalRoleName
                                        }))}>
                                    </Select>
                                    <div className="mb-10">
                                        <label className="sortbytitle"><h6>Menu</h6></label>
                                        <Select
                                            value={menuList.find(menu => menu.internalMenuId === menuId) ? {
                                                value: menuId,
                                                label: menuList.find(menu => menu.internalMenuId === menuId).internalMenuTitle
                                            } : null}
                                            onChange={(e) => {
                                                setMenuId(e.value);
                                            }}
                                            placeholder="Select Menu"
                                            required
                                            options={menuList.map(menu => ({
                                                value: menu.internalMenuId,
                                                label: menu.internalMenuTitle
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                {isEdit ?
                                    <>
                                        <div className="row">
                                            <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                                <label className="form-label">Status</label>
                                            </div>
                                            <div className="mb-10 col-md-2" style={{ paddingTop: "1rem" }}>
                                                <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                    <input
                                                        className="form-check-input text-end"
                                                        type="checkbox"
                                                        checked={menuRoleStatus === '1'}
                                                        id="rolePermissionStatus"
                                                        onChange={(e) => {
                                                            setMenuRoleStatus(e.target.checked ? '1' : '0')
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null
                                }
                                <ModalFooter>
                                    <Button
                                        className="btn-primary text-uppercase"
                                        variant="success"
                                        type="submit"
                                        onClick={handleSubmit}
                                    >
                                        <b><i className="fas fa-save" />Save</b>
                                    </Button>
                                </ModalFooter>
                            </form>
                        </ModalBody>
                    </Modal>
                )
            }
        </>
    );
};

export default MenuRole;